<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Bank payments</h1>

		<div class="margin-top">
			<button v-on:click="showAddPayment = !showAddPayment">Add</button>
			<div v-if="showAddPayment">
				<AddBankPayment class="margin-top" v-on:created="load()" />
			</div>
		</div>

		<Table class="margin-top" :rows="payments" :columns="columns" />
	</div>
</template>

<script>
import Vue from 'vue'
import AddBankPayment from '@/components/AddBankPayment.vue'

export default {
  components: {
    AddBankPayment
  },
  data: () => ({
    showAddPayment: false,
    loading: false,
    saving: false,
    addPayment: {
      mode: 0,
      regNo: '',
      accountNo: '',
      amount: 0,
      reason: '',
      orderId: '',
      currencyId: 1,
      customerId: '',
      comment: ''
    },
    columns: {
      id: {
        name: 'ID'
      },
      reg_no: {
        name: 'Reg. no'
      },
      account_no: {
        name: 'Account no.'
      },
      amount: {
        name: 'Amount'
      },
      currency: {
        name: 'Currency'
      },
      transfer_date: {
        name: 'Transfer date'
      },
      orderId: {
        name: 'Order'
      },
      orderValue: {
        name: 'Woocommerce total'
      },
      comment: {
        name: 'Comment'
      },
      predefined_reason: {
        name: 'Reason'
      }
    },
    bankPayments: {}
  }),
  computed: {
    payments () {
      var list = []
      for (var i in this.bankPayments) {
        var payment = this.bankPayments[i]
        payment.orderId = {
          type: 'link',
          title: payment.order_id,
          url: `${process.env.VUE_APP_WP_URL}/post.php?post=` + payment.order_id + '&action=edit'
        }
        if (payment.amount > 0 && !payment.orderIsPaid) {
          payment.menu = [{
            name: 'Finalize',
            onClick: (row) => {
              this.finalize(row.id)
            },
            disabled: this.saving
          }]
        }
        list.push(payment)
      }
      return list
    }
  },
  methods: {
    load () {
      Vue.api.get('/bank-payment', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.bankPayments = data
      })
    },
    finalize (id) {
      var updateInvoice = false
      for (var i in this.payments) {
        if (this.payments[i].id == id) {
          if (confirm('Do you want to update the invoice as well? The bank transfer amount is ' +
							this.payments[i].amount + ' and Woocommerce total is ' + this.payments[i].orderValue)) {
            updateInvoice = true
          }
        }
      }

      Vue.api.post('/bank-payment/' + id + '/finalize', {
        update_invoice: updateInvoice
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => this.$router.go(0)
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
